import React, { useState, useEffect, useRef } from 'react'
import { loginByEmail, sendEmailVerificationCode } from './service'
import styles from './login.module.css'

const CountdownTime = 60

function Step1({
    email, back, loginCallback
}: {
    email: string, back: () => void, loginCallback: (d: any) => void, 
}) {
    const [vcode, setVCode] = useState('')
    const [showErrTip, toggleErrTip] = useState(false)
    const [errContent, setErrContent] = useState('')
    const [countdown, isCountdown] = useState(true)
    const [leftTime, setLeftTime] = useState('')
    const timer = useRef<any>(null)
    const submitFlag = useRef(false)
    const sendFlag = useRef(false)

    useEffect(() => {
        if (countdown) {
            let ct = CountdownTime
            setLeftTime(`${ct}s`)
            timer.current = setInterval(() => {
                ct -= 1
                if (ct >= 0) {
                    setLeftTime(`${ct}s`)
                } else {
                    isCountdown(false)
                }
            }, 1000)

            return () => {
                clearInterval(timer.current)
            }
        }
    }, [countdown])

    const inputVCode = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target
        setVCode(value)
    }

    const sendVCode = () => {
        toggleErrTip(false)
        if (sendFlag.current) {
            return
        }
        sendFlag.current = true
        sendEmailVerificationCode(email).then(() => {
            isCountdown(true)
        }).catch((e: { message: React.SetStateAction<string> }) => {
            setErrContent(e.message)
            toggleErrTip(true)
        }).finally(() => {
            sendFlag.current = false
        })
    }

    const submit = () => {
        toggleErrTip(false)
        const value = (vcode || '').trim()
        if (!value) {
            return setVCode('')
        }
        if (submitFlag.current) {
            return
        }
        submitFlag.current = true
        loginByEmail(email, value).then((data: any) => {
            loginCallback(data)
        }).catch((e: { message: React.SetStateAction<string> }) => {
            setErrContent(e.message)
            toggleErrTip(true)
        }).finally(() => {
            submitFlag.current = false
        })
    }

    const enterVCode = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            submit()
        }
    }

    return <div className={styles['login-step-layout']}>
        <h2 className={styles['login-step-title']}>Verification Code</h2>
        <div className={styles['login-vc-tip-wrapper']}>
            <p className={styles['login-vc-tip']}>Verification code has been sent to</p>
            <p className={styles['login-vc-tip']}>{email}</p>
        </div>
        <div className={styles['login-vc-row']}>
            {
                showErrTip && <div className={styles['vc-err-tip-wrapper']}>
                    <p className={styles['vc-err-tip']}>{errContent}</p>
                </div>
            }
            <input className={styles['login-input']} placeholder="Enter Code" value={vcode} onChange={inputVCode} onKeyDown={enterVCode}></input>
            {
                countdown
                    ? <span className={styles['countdown']}>{leftTime}</span>
                    : <span className={styles['countdown-retry']} onClick={sendVCode}>Resend</span>
            }
        </div>
        <div className={styles['login-btn-row']}>
            <button className={styles['login-main-btn']} onClick={submit}>Next</button>
        </div>
        <div className={styles['login-addi-btn-row']}>
            <button className={styles['login-addi-btn']} onClick={back}>Back</button>
        </div>
    </div>
}

export default Step1